import moment from "moment";
import React, { Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";

import { updateActiveDetailListing } from "@/reducers/clientcandidatedetail";

import CandidateProfileCalendar from "./CandidateProfileCalendar";
import CandidateDetailSkeleton from "./Listing/CandidateRightFullProfileInfo/CandidateDetailSkeleton";
import ProgressBar from "./ProgressBar";
import { candidateGetComplianceClass } from "../../../../utilities/utils";
import ComplianceInfoIcon from "../../../Icons/ComplianceInfoIcon";
import LiveTimerTooltip from "../contracts/Unfilled/LiveTimerTooltip";

/**
 * A functional component for rendering the candidate profile details.
 */
const CandidateProfile = () => {
  const { showProfile, candidateDetails, candidateDetLoading } = useSelector(
    (state) => state.clientCandidateDetail,
  );
  const { profile_percent, shift_completed } = candidateDetails;
  const dispatch = useDispatch();

  const {
    license_number = "-",
    smart_card_number = "-",
    override_compliance_expiration_enddate = false,
  } = candidateDetails;

  return (
    <div className={`CandidateProfile_Wrapper overflow-hidden`}>
      <div className="grid">
        <div className="bg-white !pt-[20px] md:py-0">
          {/* reg no and smart card no */}
          {candidateDetLoading ? (
            Array.from({ length: 1 }).map((_, index) => (
              <Fragment key={index}>
                <div className="flex justify-between gap-2 px-4">
                  <CandidateDetailSkeleton.CandidateRightProfile
                    SkeletonNumber={1}
                    height={13}
                  />
                </div>
              </Fragment>
            ))
          ) : (
            <>
              <div className="flex flex-wrap gap-4 px-4 sm:gap-6">
                <div className="flex place-items-start gap-2">
                  <span className="text-sm font-normal text-txtColor">
                    Reg No.
                  </span>
                  <div className="grid place-items-center overflow-hidden whitespace-nowrap rounded-md text-sm font-medium text-txtDark">
                    {license_number || "-"}
                  </div>
                </div>
                <div className="flex place-items-start gap-2">
                  <span className="text-sm font-normal text-txtColor">
                    SmartCard No.
                  </span>
                  <div className="grid place-items-center overflow-hidden whitespace-nowrap rounded-md text-sm font-medium text-txtDark">
                    {smart_card_number || "-"}
                  </div>
                </div>
              </div>
            </>
          )}

          <hr className="my-4 border-t-lightblue" />

          {/* compliance */}
          <div className="grid gap-3 px-4 py-0">
            {candidateDetLoading ? (
              Array.from({ length: 1 }).map((_, index) => (
                <Fragment key={index}>
                  <CandidateDetailSkeleton.CandidateRightProfile
                    SkeletonNumber={2}
                    height={10}
                    marginTop={"1px"}
                  />
                </Fragment>
              ))
            ) : (
              <>
                <div
                  className="flex w-fit cursor-pointer items-center justify-start gap-2"
                  onClick={() => {
                    dispatch(updateActiveDetailListing("compliance"));
                  }}
                >
                  <div className="flex items-center gap-1">
                    <span
                      className={` ${candidateGetComplianceClass(
                        profile_percent,
                      )} !text-sm font-medium leading-[normal]`}
                      // role="button"
                    >
                      {profile_percent || "0"}%
                    </span>
                    <span className="text-sm font-medium leading-[normal] text-black">
                      Compliance
                    </span>
                  </div>
                  <div className="flex items-center gap-2">
                    {override_compliance_expiration_enddate ? (
                      <>
                        <ComplianceInfoIcon
                          cls={"text-txtColor w-[19px] h-[19px]"}
                        />
                        <LiveTimerTooltip
                          actionedAt=""
                          publisheddAt={moment(
                            override_compliance_expiration_enddate,
                          ).format("DD/MM/YY 23:59")}
                          cls="text-red w-[20px] h-[20px]"
                          type="invitedTimer"
                          text="candidate_details_compliance"
                        />
                      </>
                    ) : null}
                  </div>
                </div>

                <ProgressBar profile_percent={profile_percent} />
              </>
            )}
          </div>

          <hr className="my-4 border-t-lightblue" />
        </div>
        <div className="rounded-b-lg rounded-r-lg bg-white px-4">
          <CandidateProfileCalendar />
        </div>
      </div>
    </div>
  );
};

export default CandidateProfile;
